module.exports = __webpack_public_path__ + "static/media/Cabs2.0-275-75-A.6bd805d8.png";